import { RcContext } from "../../remote-control-ng/context/rcContext";
import { Device2DeskMessage } from "../messages/pocket-com";
import { BaseCommand } from "./baseCommand";

export class Device2DeskCommand extends BaseCommand<Device2DeskMessage> {
    constructor() {
        super(Device2DeskMessage);
    }

    protected override doProcess(message: Device2DeskMessage): void {
        if (message.returnCode)
            RcContext.instance.session.setLastError(message.returnCode);
    }
}